import type { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import type { MouseEvent } from 'react';
import type {
    IDraggingEventPayload,
} from '@src/slide/application/service/edit-action-services/drag-element-handler/drag-element-handler.interface';
import type {
    IResizingEventPayload,
} from '@src/slide/application/service/edit-action-services/resize-element-handler/resize-element-handler.interface';
import type { IActiveSnapGridLine } from '@src/slide/application/service/snap-line-service/interface/line.interface';
import type {
    MovementDirection,
    OperationAnchor,
} from '@src/slide/application/service/snap-line-service/interface/orient.interface';
import { IPoint } from '@src/slide/infrastructure/module/independent/graphic/point/point.interface';

export interface ISnapLineService {
    context: IContextDetail;
    enableState: boolean;
    getActiveSnapLines(): IActiveSnapGridLine[];
    handleNotifyEvent(payload: ProcessingEventPayload): void;
    toggleSnapLine(): void;
}

export interface SnapLineContextOption {
    maxAdsorbGap: number;     // 吸附距离
}

export interface IContextDetail {
    /**
     * 操作过程元素自身属性的 nextSize，由上层传递下来
     */
    nextSize: IFrame;
    /**
     * 元素的 originalSize，由上层传递下来
     */
    originalSize: IFrame;
    /**
     * 元素的宽高比
     */
    elementScale: number;
    /**
     * 元素在画布上，进行吸附探测的 frame 数据
     */
    detectFrame: IFrame;
    /**
     * 自身的nextSize，转换为在画布上的数据
     */
    nextSizeOnSlide: IFrame;
    /**
     * 操作的原始 resizeNode 锚点数据，由 mode 直接映射而来
     */
    originOperationAnchor: OperationAnchor;
    /**
     * 操作事件
     */
    mouseEvent: MouseEvent;
    /**
     * 操作移动趋势
     */
    movingDirection: MovementDirection;
    /**
     * 在当前操作下实时的锚点，用于判定后续操作的方向, 在当前slide上是什么方向的就是什么方向
     */
    operationAnchorOnSlide: OperationAnchor;
    /**
     * 操作类型
     */
    operationType: OperationType;
    /**
     * editProcess 的 sizeMap 数据
     */
    sizeMap?: Map<string, any>;
    /**
     * 画布缩放数据
     */
    scale: number;
    /**
     * 在画布上的rotate
     */
    rotateOnSlide: number;
    /**
     * 元素是否锁定横纵比
     */
    noChangeAspect: boolean;
    /**
     * debug专用属性
     */
    elementGrids?: any[];
    /**
     * debug专用属性
     */
    detectGrids?: any[];
    /**
     * debug专用属性
     */
    adsorbPoints?: IPoint[];
    /**
     * debug专用属性
     */
    beforeAdsorbPoints?: IPoint[];
}

export enum OperationType {
    MOVE = 'move',
    RESIZE = 'resize',
}

export type ProcessingEventPayload = (IDraggingEventPayload | IResizingEventPayload);

export interface IAdsorbResult {
    framePatch: IFrame;
    frameOnSlide: IFrame;
    afterAdsorbFrame: IFrame;
}
